import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {plainToClass} from 'class-transformer';

import {BaseService} from './base.service';
import {User, UserForAuth} from '@models/users';
import {BroadcastChannelService} from '@services/broadcast-channel.service';

@Injectable()
export class FamilyRoomDirectoryService extends BaseService {
  userDataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  constructor(protected override http: HttpClient, protected override broadcastChannelService: BroadcastChannelService) {
    super(http, broadcastChannelService);
  }

  get userData(): Observable<any[]> {
    return this.userDataSubject.asObservable();
  }

  getFamilyRoomDirectory(): Observable<any> {
    return this.get(`${this.baseUrl}/familyRoomDirectory`).pipe(map(
      data => {
        return data;
      },
      error => {
        return error;
      }
    ));
  }

  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    const endpoint = `${this.baseUrl}/familyRoomFile`;

    return this.post(endpoint, formData);

  }

  updateFamilyRoomIndividual(person): Observable<any> {
    const endpoint = `${this.baseUrl}/familyRoomIndividual`;

    return this.put(endpoint, person);
  }
}
